import React from 'react';
import { Outlet, Route, useLocation, useMatch } from 'react-router-dom';
import List from './pages/List';
import SellTickets, { path as sellTicketsPath, link as sellTicketsSubLink } from './pages/Sell';
import SellItem, { path as sellItemPath, link as sellItemSubLink } from './pages/SellItem';

export const path = '/tickets';
export const link = path;

export const sellLink = (...params) => link+'/'+sellTicketsSubLink(...params);
export const sellItemLink = (...params) => link+'/'+sellItemSubLink(...params);

const Tickets = () => { 
    const match = useMatch(path);

    if (match) { //If tickets list
        return <List />;
    }

    return <Outlet />; //If sell tickets or sell item
    
}

Tickets.path = path;

export default Tickets;
